import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Card, Col, Form, FormControl, Row } from 'react-bootstrap';

const EditExpedientePil = ({
  currentExpedientePil,
  saveExpedientePil,
  closeModal
}) => {
  const [expedientePil, setExpedientePil] = useState(currentExpedientePil);
  return (
    <Card style={{ width: '100%' }}>
      <Card.Body>
        <Row>
          <Col>
            <Form.Group className="mb-4">
              <Form.Label>Expediente PIL</Form.Label>
              <FormControl
                onChange={e => setExpedientePil(e.target.value)}
                type="text"
                defaultValue={expedientePil}
              />
            </Form.Group>
          </Col>
        </Row>

        <Row>
          <Col>
            <Button
              type="button"
              color="primary"
              size="sm"
              onClick={() => {
                saveExpedientePil(expedientePil);
                closeModal();
              }}
            >
              Guardar
            </Button>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

EditExpedientePil.propTypes = {
  idQueja: PropTypes.string.isRequired,
  closeModal: PropTypes.func,
  currentExpedientePil: PropTypes.string,
  saveExpedientePil: PropTypes.func
};

export default EditExpedientePil;
